module.exports = __webpack_public_path__ + "static/media/icon_propose.82a5b92b.svg";